"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const label_1 = __importDefault(require("../label/label"));
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const typesConstants_1 = require("../../constants/typesConstants");
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const authSlice_1 = require("../../features/auth/authSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const ProfileInfo = ({ officer }) => {
    const dispatch = useAppDispatch_1.default();
    const isDisabled = !typesConstants_1.OFFICER_TYPE_WITH_SCHEDULES.includes(officer.officer_type);
    const text = officer.schedule_mode ? 'Schedule Mode' : 'Manual Mode';
    const currentMode = officer.schedule_mode;
    const onPress = () => {
        dispatch(authSlice_1.toggleScheduleMode());
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.minHeight] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginLeftTwenty },
            react_1.default.createElement(boxTitle_1.default, { title: "Basic Information" })),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen, styles_1.default.flexDirectionColumn] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(label_1.default, { subheading: "Email", title: officer.email })),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(label_1.default, { subheading: "Full Name", title: `${officer.first_name} ${officer.last_name}` }))),
            react_1.default.createElement(label_1.default, { subheading: "Identification Number", title: officer.id })),
        officer.scheduling_type === typesConstants_1.SCHEDULING_TYPE_MANUAL && (react_1.default.createElement(button_1.default, { onPress: onPress, eventName: eventConstants_1.TOGGLE_SCHEDULE_MODE_BUTTON, text: text, disabled: isDisabled, fill: currentMode }))));
};
exports.default = ProfileInfo;
